import { useEffect, useState } from "react";
import { ChartBar, Buildings, ChatCircleDots } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function Oversight() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/api/oversight").then(({ data }) => setData(data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5 font-sans" data-testid="oversight-screen">
      <div>
        <p className="text-[11px] font-bold uppercase tracking-[0.32em] text-white/50">Society-wide</p>
        <h1 className="font-display text-3xl font-extrabold text-white">Oversight</h1>
      </div>

      <div className="card relative overflow-hidden p-5">
        <div className="absolute -right-12 -top-12 h-44 w-44 rounded-full bg-neon-cyan/20 blur-3xl" />
        <Buildings size={22} weight="duotone" className="text-neon-cyan" />
        <p className="mt-3 font-display text-3xl font-extrabold text-white">{data?.society?.occupancyPct ?? "—"}<span className="text-base font-bold text-white/55">% occupied</span></p>
        <p className="text-[12px] text-white/55">{data?.society?.occupiedFlats ?? "—"} of {data?.society?.totalFlats ?? "—"} flats have an active resident.</p>
      </div>

      <div>
        <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.22em] text-white/55">Complaints — by status</p>
        <div className="grid grid-cols-2 gap-3">
          {Object.entries(data?.complaints?.byStatus || { OPEN: 0, IN_PROGRESS: 0, RESOLVED: 0, CLOSED: 0 }).map(([k, v]) => (
            <div key={k} className="card p-4">
              <ChatCircleDots size={16} weight="duotone" className="text-neon-cyan" />
              <p className="mt-2 font-display text-2xl font-extrabold text-white">{v}</p>
              <p className="text-[10px] font-bold uppercase tracking-wider text-white/55">{k.replace("_", " ")}</p>
            </div>
          ))}
        </div>
      </div>

      <div>
        <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.22em] text-white/55">Complaints — by category</p>
        <div className="card p-4">
          {Object.entries(data?.complaints?.byCategory || {}).length === 0 ? (
            <p className="text-[13px] text-white/55">No complaints raised yet.</p>
          ) : Object.entries(data.complaints.byCategory).map(([k, v]) => (
            <div key={k} className="flex items-center justify-between border-b border-white/5 py-2 last:border-0">
              <span className="text-[13px] text-white/80">{k}</span>
              <span className="chip">{v}</span>
            </div>
          ))}
        </div>
      </div>

      <p className="text-center text-[11px] text-white/40"><ChartBar size={12} className="-mt-0.5 mr-1 inline" weight="fill" /> Live snapshot · updates on refresh</p>
    </div>
  );
}
